const faqData = {
    general: {
        name: "General Questions",
        questions: [
          {
            id: 1,
            question: "What makes organic pads different from regular pads?",
            answer: "Organic pads are made from 100% natural, chemical-free cotton grown without pesticides or harmful chemicals. They are biodegradable, hypoallergenic, and free from synthetic materials, plastic, chlorine bleach, and artificial fragrances. This makes them safer for both your body and the environment.",
            tags: ["basics", "materials", "organic", "comparison"],
          },
          {
            id: 2,
            question: "Are organic pads better for sensitive skin?",
            answer: "Yes, organic pads are ideal for sensitive skin as they're made from pure cotton without harsh chemicals, dyes, or fragrances that can cause irritation. The breathable, natural materials reduce the risk of allergic reactions and skin sensitivities commonly associated with conventional pads.",
            tags: ["health", "sensitivity", "benefits"],
          },
          {
            id: 3,
            question: "How do organic pads help the environment?",
            answer: "Organic pads significantly reduce environmental impact through biodegradable materials, plastic-free packaging, and sustainable manufacturing processes. Unlike conventional pads that take 500-800 years to decompose, organic pads break down naturally within 6-12 months, reducing landfill waste and ocean pollution.",
            tags: ["environment", "sustainability", "eco-friendly"],
          }
        ]
      },
      usage: {
        name: "Usage & Care",
        questions: [
          {
            id: 4,
            question: "How often should I change my organic pad?",
            answer: "For optimal hygiene and comfort, change your organic pad every 4-6 hours or more frequently during heavy flow days. While organic pads are highly absorbent, regular changing helps prevent leakage and maintains freshness. Never wear the same pad for more than 8 hours.",
            tags: ["usage", "care", "hygiene"],
          },
          {
            id: 5,
            question: "Can I use organic pads overnight?",
            answer: "Yes, organic pads are perfect for overnight use. Choose our overnight variety which offers extended length and enhanced absorption for complete protection while you sleep. The breathable organic cotton helps prevent moisture buildup during longer wear times.",
            tags: ["usage", "overnight", "protection"],
          }
        ]
      },
      health: {
        name: "Health & Safety",
        questions: [
          {
            id: 6,
            question: "What health benefits do organic pads offer compared to regular pads?",
            answer: "Organic pads provide multiple health benefits: they reduce exposure to harmful chemicals and synthetic materials, lower the risk of irritation and allergic reactions, allow better air circulation to prevent infections, and contain no endocrine-disrupting chemicals commonly found in conventional pads.",
            tags: ["health", "benefits", "safety"],
          },
          {
            id: 7,
            question: "Are organic pads safe for all skin types?",
            answer: "Yes, organic pads are safe for all skin types, including very sensitive skin. The pure organic cotton and absence of harmful chemicals make them hypoallergenic and suitable for everyone. They're particularly beneficial for those with skin sensitivities or conditions like eczema.",
            tags: ["safety", "skin", "sensitivity"],
          }
        ]
      }
};
export default faqData;
